// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var PayorPlanType;
(function (PayorPlanType) {
    PayorPlanType[PayorPlanType["HMHEALTH"] = 19] = "HMHEALTH";
    PayorPlanType[PayorPlanType["AUTOINJ"] = 21] = "AUTOINJ";
    PayorPlanType[PayorPlanType["COMMPL"] = 22] = "COMMPL";
    PayorPlanType[PayorPlanType["FEDPL"] = 23] = "FEDPL";
    PayorPlanType[PayorPlanType["MEDAD"] = 24] = "MEDAD";
    PayorPlanType[PayorPlanType["MDCRAD"] = 25] = "MDCRAD";
    PayorPlanType[PayorPlanType["MDCRB"] = 26] = "MDCRB";
    PayorPlanType[PayorPlanType["MDCRD"] = 27] = "MDCRD";
    PayorPlanType[PayorPlanType["MDGP"] = 28] = "MDGP";
    PayorPlanType[PayorPlanType["VATC"] = 29] = "VATC";
    PayorPlanType[PayorPlanType["WRKCMP"] = 30] = "WRKCMP";
    PayorPlanType[PayorPlanType["PLAN"] = 31] = "PLAN";
    PayorPlanType[PayorPlanType["DMEP"] = 33] = "DMEP";
    PayorPlanType[PayorPlanType["MCMP"] = 34] = "MCMP";
    PayorPlanType[PayorPlanType["SPAP"] = 35] = "SPAP";
    PayorPlanType[PayorPlanType["MEDAB"] = 36] = "MEDAB";
    PayorPlanType[PayorPlanType["ADAP"] = 37] = "ADAP";
    PayorPlanType[PayorPlanType["STPL"] = 38] = "STPL";
    PayorPlanType[PayorPlanType["EPO"] = 40] = "EPO";
    PayorPlanType[PayorPlanType["INDEM"] = 41] = "INDEM";
    PayorPlanType[PayorPlanType["HMO"] = 42] = "HMO";
    PayorPlanType[PayorPlanType["POSP"] = 43] = "POSP";
    PayorPlanType[PayorPlanType["PPO"] = 44] = "PPO";
    PayorPlanType[PayorPlanType["MDCRA"] = 48] = "MDCRA";
    PayorPlanType[PayorPlanType["SecSupp"] = 54] = "SecSupp";
    PayorPlanType[PayorPlanType["Employee"] = 63] = "Employee";
})(PayorPlanType || (PayorPlanType = {}));
//# sourceMappingURL=payorPlanType.js.map